import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { CHAT_SKILLS_QUERY_KEY } from 'src/UI/app-container/chats/useChatSkills';

export default function useDeleteTenantSkill() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ skillId, unshare }: { skillId: string; unshare: boolean }) =>
      api.delete(`/tenant/custom-skills/${skillId}${unshare ? '?unshare=true' : ''}`),
    onSuccess: (_, { unshare }) => {
      queryClient.invalidateQueries({ queryKey: ['tenant', 'custom-skills'] });
      queryClient.invalidateQueries({ queryKey: CHAT_SKILLS_QUERY_KEY });
      if (unshare) queryClient.invalidateQueries({ queryKey: ['skill-library'] });
    },
  });
}
